import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import { ListItemMostBookedRegion } from './list-item'
import { MostBookedRegionType } from '../../location-picker.type'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import { pushToGTM } from '../../../../../utils/pushToGTM'

interface Props {
  items: MostBookedRegionType[]
  onItemSelected: (item: MostBookedRegionType) => void
  isMobile?: boolean
  titleTopDestinations?: React.ReactNode
  isLocationSelected: boolean
}

export const ListMostBookedRegions: React.FC<Props> = ({
  items,
  onItemSelected,
  isMobile,
  titleTopDestinations,
  isLocationSelected,
}) => {
  const handleItemClick = (item: MostBookedRegionType) => {
    onItemSelected(item)
    pushToGTM({
      event: 'LocationMostBookedRegionChoiceClick',
      selectedItem: item,
    })
    Mixpanel.track('LocationMostBookedRegionChoiceClick', {
      selectedItem: item,
    })
  }

  const handleClick = (item: MostBookedRegionType) => (e: React.MouseEvent) => {
    e.stopPropagation()
    handleItemClick(item)
  }

  if (isMobile && isLocationSelected) {
    return null
  }

  return (
    <div
      className={clsx(s.list, s.listMostBookedRegions, {
        [s.mobile]: isMobile,
      })}
      style={{ backgroundColor: isMobile ? 'white' : '' }}
    >
      {titleTopDestinations && (
        <div className={s.title}>{titleTopDestinations}</div>
      )}
      <div className={s.listRevamp}>
        {items.map((item) => (
          <ListItemMostBookedRegion
            key={item.placeId}
            item={item}
            onClick={handleClick(item)}
          />
        ))}
      </div>
    </div>
  )
}
